import { Controller } from "@hotwired/stimulus"
import pageMessageBroker from "../page_message_broker"

// Connects to data-controller="claims-experience-modal-trigger"
export default class extends Controller {
  static values = {
    renewalId: String
  }

  connect() {
    console.log("ClaimsExperienceModalTriggerController connected")
  }

  open() {
    console.log("Dispatching open-claims-experience-modal event")
    pageMessageBroker.dispatch("open-claims-experience-modal", {
      renewalId: this.renewalIdValue
    })
  }
}